import { api, type ApiResponse } from "./client";
import type { Contact } from "@/types/contact";

export const contactsApi = {
  list: (params?: Record<string, string>): Promise<ApiResponse<Contact[]>> =>
    api.get("/contacts", params),

  get: (id: number): Promise<ApiResponse<Contact>> =>
    api.get(`/contacts/${id}`),

  create: (data: Partial<Contact>): Promise<ApiResponse<Contact>> =>
    api.post("/contacts", data),

  update: (id: number, data: Partial<Contact>): Promise<ApiResponse<Contact>> =>
    api.put(`/contacts/${id}`, data),

  delete: (id: number): Promise<ApiResponse<Contact>> =>
    api.del(`/contacts/${id}`),
};
